module.exports = __webpack_public_path__ + "img/hero_image_bg.b7ec26cc.svg";